/* One name field follows the purchased certificate option, including back/forward. */
document.querySelectorAll('[data-certificate-name-field]').forEach(function (field) {
  var form = field.closest('form');
  var input = field.querySelector('input');
  var id = form && form.querySelector('[name="id"]');
  var data = form && form.querySelector('[data-variants]');
  if (!form || !input || !id || field.dataset.mixed !== 'true' || !data) return;
  var variants;
  try { variants = JSON.parse(data.textContent); } catch (error) { return; }
  var update = function () {
    var selected = variants.find(function (variant) { return String(variant.id) === id.value; });
    var required = !!selected && selected.options.includes('With their name');
    field.hidden = !required;
    input.disabled = !required;
    input.required = required;
  };
  id.addEventListener('change', update);
  window.addEventListener('pageshow', update);
  update();
});
